// packages/core/src/learning/core-modules/index.ts
// ─────────────────────────────────────────────────────────────────────────
// Registry for the NISK CORE PATH — the 12-module motivation-first curriculum.
// Each module lives in its own file (core-modules/<module-id>.ts) exporting one
// `LearningModule`. This barrel imports them and assembles CORE_PATH_MODULES,
// which LearningData.ts uses as the live curriculum.
//
// Mirrors the schools/ registry pattern: drop a module file in this folder,
// add ONE import + ONE array entry below. Modules render in array order
// (each module also carries its own `order` field within its tier).
//
// AUTHORING STATUS: modules are added one at a time via the generator prompt,
// in path order (money-buys-options first). Until a module is authored, it
// simply isn't in the array — the path shows fewer modules, nothing breaks.
//
// The 12 modules (product-locked order):
//    1. money-buys-options          (tier: orientation)
//    2. your-money-snapshot         (tier: control)
//    3. cash-flow-control           (tier: control)
//    4. debt-credit-interest        (tier: control)
//    5. safety-before-speed         (tier: stability)
//    6. compounding-first-investing (tier: growth)
//    7. long-term-investing-basics  (tier: growth)
//    8. income-is-a-lever           (tier: growth)
//    9. money-psychology            (tier: growth)
//   10. freedom-math                (tier: freedom-path)
//   11. big-life-decisions          (tier: life-design)
//   12. build-your-plan             (tier: life-design)
// ─────────────────────────────────────────────────────────────────────────

import { LearningModule } from '../LearningTypes';

// ── Authored module imports (added one per generation pass) ───────────────
import { MONEY_BUYS_OPTIONS_MODULE } from './money-buys-options';
import { YOUR_MONEY_SNAPSHOT_MODULE } from './your-money-snapshot';
import { CASH_FLOW_CONTROL_MODULE } from './cash-flow-control';
import { DEBT_CREDIT_INTEREST_MODULE } from './debt-credit-interest';
import { SAFETY_BEFORE_SPEED_MODULE } from './safety-before-speed';
import { COMPOUNDING_FIRST_INVESTING_MODULE } from './compounding-first-investing';
import { LONG_TERM_INVESTING_BASICS_MODULE } from './long-term-investing-basics';
import { INCOME_IS_A_LEVER_MODULE } from './income-is-a-lever';
import { MONEY_PSYCHOLOGY_MODULE } from './money-psychology';
import { FREEDOM_MATH_MODULE } from './freedom-math';
import { BIG_LIFE_DECISIONS_MODULE } from './big-life-decisions';
import { BUILD_YOUR_PLAN_MODULE } from './build-your-plan';

export const CORE_PATH_MODULES: LearningModule[] = [
	MONEY_BUYS_OPTIONS_MODULE,
	YOUR_MONEY_SNAPSHOT_MODULE,
	CASH_FLOW_CONTROL_MODULE,
	DEBT_CREDIT_INTEREST_MODULE,
	SAFETY_BEFORE_SPEED_MODULE,
	COMPOUNDING_FIRST_INVESTING_MODULE,
	LONG_TERM_INVESTING_BASICS_MODULE,
	INCOME_IS_A_LEVER_MODULE,
	MONEY_PSYCHOLOGY_MODULE,
	FREEDOM_MATH_MODULE,
	BIG_LIFE_DECISIONS_MODULE,
	BUILD_YOUR_PLAN_MODULE,
];
